<!-- For Credit Details -->
<div class="row p-3 wccard">
  <div class="w-100">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="d-flex justify-content-center align-items-center"
              style="width: 61px; height: 61px; background-color: rgba(235, 121, 79, 0.2); border-radius: 4px;">
              <i style="font-size: 36px; font-weight: 900; color: #EB794F;" class="fa-solid fa-coins"></i>
            </div>

            <div class="ml-2 d-flex flex-column">
              <span class="f-14 font-weight-500" style="color: #969696;">Total credits Received</span>
              <span class="f-24 font-weight-600 mt-1" style="color: #484B59;">
                {{planDetails?.isteammember ? planDetails?.reservedbasiccontactcreditscount :
                (+planDetails?.basiccontactenrichmentcredits || 0) + (+planDetails?.adhocbasiccontactenrichmentcredits || 0)}}
              </span>
            </div>
          </div>

          <span style="color: #969696;">
            <i class="fa-regular fa-greater-than"></i>
          </span>
        </div>
      </div>

      <div class="col">
        <div class="d-flex">
          <div class="d-flex justify-content-center align-items-center"
            style="width: 61px; height: 61px; background-color: rgba(79, 176, 235, 0.2); border-radius: 4px;">
            <i style="font-size: 36px; font-weight: 900; color: #4FB0EB;" class="fa-solid fa-coins"></i>
          </div>
          <div class="ml-2  d-flex flex-column">
            <span class="f-14 font-weight-500" style="color: #969696;">Available credits</span>
            <span class="f-24 font-weight-600 mt-1" style="color: #484B59;">
              {{planDetails?.balancebasiccontactenrichmentcredits}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- For Choose Tabs -->
<div class="row p-3 mt-1 wccard">
  <div class="d-flex">
    <span class="pointer f-14 font-weight-500" [ngStyle]="{'color': showTeamCreditPoolTab ? '#2E93A1': '#484B59'}"
      (click)="onTabChange('team-credit-pool-tab')">Team Credit Pool</span>
    <span class="pointer f-14 ml-4 font-weight-500" [ngStyle]="{'color': showActivityTab ? '#2E93A1': '#484B59'}"
      (click)="onTabChange('activity-tab')">Activity</span>
  </div>
</div>


<!-- For Credit Pool -->
<div class="row mt-1 wccard" *ngIf="showTeamCreditPoolTab">

  <!-- Create Team Credit Pool -->
  <div class="text-center p-5 d-flex flex-column justify-content-center align-items-center" *ngIf="showCreateTeamCreditPoolTab && !planDetails?.isteammember">
    <img style="width: 83px; height: 70px;" src="../../../assets/create-credit-pool.png" alt="logo">
    <span class="f-14 font-weight-400" style="color: #969696; padding: 21px 236px 23px 236px;">Create a shared credit pool to distribute credits to
      your team members. Once the pool is set up, you can allocate
      credits from your available balance to the pool and assign them to individual users.</span>
    <button data-testid="auto-app-credits-button-1" class="btn-trms-medium" (click)="createTeamCreditPool()">Create Team Credit Pool</button>
  </div>

  <!-- Add Credit To Team Pool -->
  <div class="mt-1 w-100 p-3" *ngIf="showAddCreditToTeamPool || planDetails?.isteammember">
    <span class="f-12 font-weight-400">You can add credits from your available balance to the team credit pool. These
      credits can then be assigned to
      your team members.</span>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <div class="d-flex justify-content-center align-items-center"
          style="width: 61px; height: 61px; background-color: rgba(144, 226, 226, 0.2); border-radius: 4px;">
          <i style="font-size: 36px; font-weight: 900; color: #90E2E2;" class="fa-solid fa-coins"></i>
        </div>
        <div class="ml-1 d-flex flex-column">
          <span class="f-14 font-weight-500" style="color: #969696;">Available Team Credits</span>
          <span class="f-24 font-weight-600 mt-1" style="color: #484B59;" *ngIf="planDetails?.isteamadmin || planDetails?.isteammember">
            {{ planDetails?.isteamadmin ? planDetails?.pooledbalancebasiccontactenrichmentcredits :
            planDetails?.teamadmindetails?.adminpooledbalancebasiccontactenrichmentcredits}}
          </span>
            <span class="f-24 font-weight-600 mt-1" style="color: #484B59;" *ngIf="!planDetails?.isteamadmin && !planDetails?.isteammember"> 0 </span>
        </div>
      </div>
      <button data-testid="auto-app-credits-button-2" [disabled]="!planDetails?.isteamadmin" class="btn-trms-medium font-weight-600" [ngClass]="{'bg-gray': !planDetails?.isteamadmin}" (click)="addCreditToTeamPool()">Add Credits to Team Pool</button>
    </div>

  </div>

</div>


<!-- For Activity Tab -->
<div class="row mt-1" *ngIf="showActivityTab">

  <!-- If Activity Not Available -->
    <div *ngIf="allActivity.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div class="d-flex flex-column">
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <span class="f-14 font-weight-500" style="color: #969696;">No Activity Yet!</span>
      </div>
    </div>
  </div>

  <!-- If Activity Available -->
  <div class="col" *ngIf="allActivity.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Date
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Users
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Credits
        </span>
      </div>

      <div class="col-md-5">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Action
        </span>
      </div>


    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngFor="let activity of allActivity">
      <div class="col">
        <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{activity?.createdon | date: 'MMM dd, yyyy'}}</span>
        </span>
      </div>

        <div class="col">
          <span class="mb-1 pointer no-outline">
            <span class="font-weight-400" style="color: #484B59;">{{activity?.firstname ? (activity?.firstname | titlecase) :
              '-'}} {{activity?.lastname ? (activity?.lastname | titlecase) : '-'}}</span>
          </span>
        </div>

      <div class="col">
        <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{activity?.credits}}</span>
        </span>
      </div>
      
        <div class="col-md-5">
          <span class="mb-1 pointer no-outline">
            <span class="font-weight-400" style="color: #484B59;">{{activity?.action}}</span>
          </span>
        </div>

    </div>
  </div>

</div>


<!-- For Add Credits to tema pool model -->
<ng-template #addCreditTeamPoolModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <span class="f-14 font-weight-600">Add Credits to Team Pool</span>
      <span class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></span>
    </div>
    <span class="f-14 font-weight-400" style="margin-top: 12px;">Add credits from your balance to the team pool.</span>

    <hr class="w-100 mt-3 mb-3">

    <div class="">
      <div class="d-flex align-items-center justify-content-between">
        <span class="f-14 font-weight-400" style="color: #484B59;">Available Credits</span>
        <span class="f-14 font-weight-400" style="color: #484B59;">{{planDetails?.balancebasiccontactenrichmentcredits}}
        </span>
      </div>

      <div class="d-flex align-items-center justify-content-between" style="margin-top: 20px;">
        <span class="f-14 font-weight-400" style="color: #484B59;">Available Team Credits </span>
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{planDetails?.pooledbalancebasiccontactenrichmentcredits ? planDetails?.pooledbalancebasiccontactenrichmentcredits : '0'}}</span>
      </div>

      <div class="d-flex align-items-center justify-content-between" style="margin-top: 12px;">
        <span class="f-14 font-weight-400" style="color: #484B59;">Credits to Add</span>
        <input data-testid="auto-app-credits-input-1" type="number" [formControl]="creditInput" placeholder="500"
          style="width: 57px; height: 37px; outline: none; border: 1px solid #D9D9D9; border-radius: 2px; text-align: center;" [ngStyle]="{'border-color': creditExceedError ? 'red' : '#D9D9D9'}">
      </div>

      <div class="text-start text-danger mt-3" *ngIf="creditExceedError">
        <li>Credits to add cannot exceed available credits</li>
      </div>
      <div class="text-start text-danger mt-1" *ngIf="creditBelowError">
        <li>Credits to add cannot below 1</li>
      </div>

      <div class="text-right">
        <button data-testid="auto-app-credits-button-3" class="mt-5 text-center" [ngClass]="{'btn-trms-small': true,
                    'bg-gray': creditExceedError || creditBelowError || !creditInput.value,
                    'btn-disabled': creditExceedError || creditBelowError || !creditInput.value}" 
                    (click)="addCreditsAPI()"
          [disabled]="showSpinnerLoader || creditExceedError || creditBelowError || !creditInput.value">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showSpinnerLoader }"
            [ngStyle]="{ width: showSpinnerLoader ? '20px' : '', height: showSpinnerLoader ? '20px' : '' }">
            {{ showSpinnerLoader ? '' : 'Add Credits' }}
          </span>
        </button>
      </div>

    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>